import { type AnyAction } from 'redux';
import actions from './actions';
import { type RootState } from '@/types/app';
import { type IOrganizationState } from '@/types/organization';

/** @TODO decouple IOrganizationState from the SDK response type. */
export const initialState: IOrganizationState = {
  loading: false,
  // @ts-expect-error
  id: null,
  ordering: {
    // @ts-expect-error
    driver_id: null,
    // @ts-expect-error
    label: null,
    environment: 'sandbox',
  },
  organization: {
    // @ts-expect-error
    id: null,
    created_at: '',
    updated_at: '',
    deleted_at: '',
    label: '',
    // @ts-expect-error
    ordering_driver_id: null,
    loyalty_driver_id: null,
    // @ts-expect-error
    external_provider_id: null,
    last_synced_at: '',
    nutrition_url: '',
    // @ts-expect-error
    upsell_driver_id: null,
  },
  payment: {
    // @ts-expect-error
    driver_id: null,
    label: '',
    meta: [],
  },
  loyalty: {
    // @ts-expect-error
    driver_id: null,
    label: '',
    // @ts-expect-error
    features: null,
    // @ts-expect-error
    program_type: null,
  },
  external_auth: {
    // @ts-expect-error
    driver_id: null,
    label: '',
    // @ts-expect-error
    registration_fields: null,
    // @ts-expect-error
    updatable_fields: null,
    // @ts-expect-error
    readonly_fields: null,
    // @ts-expect-error
    features: null,
  },
};

export const organization = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case actions.FETCH_ORGANIZATION:
      return Object.assign({}, state, {
        loading: true,
      });
    case actions.FETCH_ORGANIZATION_SUCCESS:
      return {
        loading: false,
        id: action.organizationConfig?.organization.id,
        ...action.organizationConfig,
      };
    case actions.FETCH_ORGANIZATION_FAIL:
      return Object.assign({}, state, {
        loading: false,
      });
    default:
      return state;
  }
};

export const organizationSliceSelector = (state: RootState) => state.app.organization;
